export const FB_SCRIPT_TEXT = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '260515522548202');
fbq('track', 'PageView');`;

export const FB_IMAGE_ATTR = {
  height: '1', width: '1', style: 'display:none', src: 'https://www.facebook.com/tr?id=260515522548202&ev=PageView&noscript=1',
};

export const GSCRIPT_SRC = 'https://www.googletagmanager.com/gtag/js?id=AW-575680129';

export const GSCRIPT_TEXT = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'AW-575680129');
`;

export const EVENT_SCRIPT_TEXT = `gtag('event', 'conversion',
{'send_to': 'AW-575680129/3MewCNy37fgCEIHdwJIC'});`;

export const EVENT_GTAG_TEXT = `function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-575680129/3MewCNy37fgCEIHdwJIC',
      'event_callback': callback
  });
  return false;
}`;

export const TDD_SCRIPT_SRC = 'https://js.adsrvr.org/up_loader.1.1.0.js';

export const TDD_SCRIPT_TEXT = `ttd_dom_ready( function() {
  if (typeof TTDUniversalPixelApi === 'function') {
      var universalPixelApi = new TTDUniversalPixelApi();
      universalPixelApi.init("lolppna", ["m5fnl6b"], "https://insight.adsrvr.org/track/up");
  }
});`;
